// extracted by mini-css-extract-plugin
export default {"ActionBarText":"_ActionBarText--YlJlV","Header":"_Header--iS0iL","Content":"_Content--VZWp6"};